import { FileCollection } from 'filelist-utils';
import { convert1D } from 'varian-converter';
import { formatSpectra } from '../../utilities/formatSpectra';
import { getInfo } from './getInfo';
import { groupByExperiments } from './groupByExperiments';
export async function readVarian(fileCollection, options = {}) {
    const { keepSource } = options;
    const experiments = groupByExperiments(fileCollection);
    let output = { spectra: [], molecules: [] };
    for (const key in experiments) {
        const { name, files } = experiments[key];
        const fileCollection = new FileCollection(files);
        const converted = await convert1D(fileCollection);
        const { info, meta } = getInfo(converted);
        info.name = name;
        const spectrum = {
            data: { ...converted.fid.data[0], x: converted.x },
            meta,
            info,
            display: { name: `${name}` },
        };
        if (files && keepSource) {
            spectrum.sourceSelector = {
                files: files.map((file) => file.relativePath),
            };
        }
        output.spectra.push(spectrum);
    }
    return formatSpectra(output);
}
//# sourceMappingURL=readVarian.js.map